module.exports = __webpack_public_path__ + "static/media/0006.ec20e92c.jpg";